export const SparklesIcon: React.FC<React.ComponentProps<'svg'>> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2026 2.70711C15.2392 2.48347 15.5608 2.48347 15.5974 2.70711L15.9132 4.63831C16.4262 7.77559 18.748 10.3115 21.828 11.0984L22.6416 11.3062C22.8422 11.3575 22.8422 11.6425 22.6416 11.6938L21.828 11.9016C18.748 12.6885 16.4262 15.2244 15.9132 18.3617L15.5974 20.2929C15.5608 20.5165 15.2392 20.5165 15.2026 20.2929L14.8869 18.3617C14.3739 15.2244 12.052 12.6885 8.97203 11.9016L8.15847 11.6938C7.95782 11.6425 7.95781 11.3575 8.15847 11.3062L8.97203 11.0984C12.052 10.3115 14.3739 7.77559 14.8869 4.63831L15.2026 2.70711Z"
        fill="currentColor"
      />
      <path
        d="M7.10125 14.7212C7.11912 14.6088 7.2809 14.6088 7.29877 14.7212L7.38425 15.2589C7.63325 16.8252 8.79631 18.0997 10.3302 18.5028C10.4296 18.5289 10.4296 18.671 10.3302 18.6972C8.79631 19.1002 7.63325 20.3747 7.38425 21.941L7.29877 22.4787C7.2809 22.5911 7.11912 22.5911 7.10125 22.4787L7.01577 21.941C6.76677 20.3747 5.60371 19.1002 4.06983 18.6972C3.97038 18.671 3.97038 18.5289 4.06983 18.5028C5.60371 18.0997 6.76677 16.8252 7.01577 15.2589L7.10125 14.7212Z"
        fill="currentColor"
      />
      <path
        d="M4.20123 2.12124C4.2191 2.00884 4.38088 2.00884 4.39875 2.12124L4.48423 2.65896C4.73323 4.22526 5.89629 5.49973 7.43017 5.90282C7.52962 5.92895 7.52962 6.07105 7.43017 6.09718C5.89629 6.50027 4.73323 7.77474 4.48423 9.34103L4.39875 9.87876C4.38088 9.99116 4.2191 9.99116 4.20123 9.87876L4.11575 9.34103C3.86675 7.77474 2.70369 6.50027 1.1698 6.09718C1.07036 6.07105 1.07036 5.92895 1.1698 5.90282C2.70369 5.49973 3.86675 4.22526 4.11575 2.65897L4.20123 2.12124Z"
        fill="currentColor"
      />
    </svg>
  );
};
